module.exports = __webpack_public_path__ + "img/remen_product3.3869f5a4.png";